import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ProductType } from '@wilson/interfaces';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { Observable, of } from 'rxjs';
import { BaseSingleSelectFilterDirective } from '../../base-single-select-filter.directive';
import { FilterService } from '../../filter.service';
import { FilterOptions } from '../../options.interface';
import { StringParserService } from '../../services/string-parser.service';

export const PRODUCT_TYPE_FILTER_OPTIONS: FilterOptions<ProductType>[] = [
  { id: ProductType.Booked, name: 'products.type.booked' },
  { id: ProductType.ActivityBased, name: 'products.type.activity_based' },
];

@Component({
  selector: 'wilson-product-type-filter',
  templateUrl: './product-type-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AsyncPipe, FormsModule, TranslatePipe, NzSelectModule],
})
export class ProductTypeFilterComponent extends BaseSingleSelectFilterDirective<
  FilterOptions<ProductType>,
  ProductType
> {
  protected readonly filterService = inject(FilterService);
  protected readonly parserService =
    inject<StringParserService<ProductType>>(StringParserService);

  constructor() {
    super('productType');
  }

  protected initializeOptions(): Observable<FilterOptions<ProductType>[]> {
    return of(PRODUCT_TYPE_FILTER_OPTIONS);
  }
}
